import { render } from "./InformationTab.vue?vue&type=template&id=99edb902"
import script from "./InformationTab.vue?vue&type=script&lang=js"
export * from "./InformationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__